module.exports = __webpack_public_path__ + "media/images/vimeo_mobile@2x-143e096d3bfc7f826eead7f7b64f8633.png";